<template>
  <v-card
    :width="$vuetify.breakpoint.xsOnly ? 'auto' : `${width}px`"
    :tile="$vuetify.breakpoint.mobile"
    :loading="isLoading"
    :disabled="isLoading"
  >
    <div v-if="$slots.header" class="header">
      <v-card-title data-card-title class="primary--text pa-4">
        <slot name="header"></slot>
      </v-card-title>
      <v-divider v-if="dividers" />
    </div>
    <v-card-text class="pa-0 popup-body">
      <slot />
    </v-card-text>
    <div v-if="$slots.footer" class="footer">
      <v-divider v-if="dividers" />
      <v-card-actions class="pa-4">
        <slot name="footer" />
      </v-card-actions>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'LayoutPopup',
  props: {
    dividers: {
      type: [Boolean],
      default: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '428'
    }
  }
};
</script>

<style lang="sass" scoped>
.popup-base-card
  padding: 0 8px

.popup-body
  max-height: 75dvh
  overflow-y: auto
  @media (max-width: 579px)
    max-height: 100%
    height: calc(100dvh - 134px)
</style>
